import { FC, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components/macro'
import { swaapPurple0 } from '../Themes'

export function Information() {
  return (
    <div style={{ alignSelf: 'center' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke={swaapPurple0}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="SwapDetailsDropdown__StyledInfoIcon-sc-18rlj6e-1 dCPoqk"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    </div>
  )
}

export function SmallInformation() {
  // @ts-ignore
  const theme = useContext(ThemeContext)
  return (
    <div style={{ alignSelf: 'center' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke={theme.text}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="SwapDetailsDropdown__StyledInfoIcon-sc-18rlj6e-1 dCPoqk"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    </div>
  )
}
